import { BaseAssessment } from 'types/api';
import { GraphTabs } from 'components/GraphTabs';
import styles from './Mechanics.module.css';
import { useConfig } from './useConfig';
import { useLeftFootData } from './useLeftFootData';

interface LeftFootProps {
  assessment: BaseAssessment;
  className?: string;
}

export const LeftFoot = (props: LeftFootProps) => {
  const { assessment, className } = props;
  const data = useLeftFootData([assessment]);
  const config = useConfig('Left Foot Mechanics', [assessment], data);
  return (
    <GraphTabs
      className={className}
      config={config}
      defaultTab="barTab"
      headerClassName={styles.header}
      heading="Left Foot Mechanics"
    />
  );
};
